import React from 'react';

import * as PopoverPrimitive from '@radix-ui/react-popover';
import PopoverArrow from './PopoverArrow';

import cn from '../../../utils/cn';

export interface PopoverContentProps
  extends React.ComponentPropsWithRef<typeof PopoverPrimitive.Content> {
  showArrow?: boolean;
  arrowClassName?: string;
  portal?: boolean;
  offset?: 'icon' | 'button' | 'text' | number;
}

const PopoverContent = ({
  className,
  portal = true,
  align = 'center',
  showArrow = true,
  arrowClassName,
  offset = 'icon',
  children,
  ...props
}: PopoverContentProps) => {
  const alignOffset = align === 'start' ? -20 : align === 'end' ? 20 : 0;

  const iconOffset = offset === 'icon' ? -10 : 0;
  const buttonOffset = offset === 'button' ? 0 : 0;
  const textOffset = offset === 'text' ? -8 : 0;
  const sideOffsetNumber = typeof offset === 'number' ? offset : 0;

  const WrapperPortal = portal ? PopoverPrimitive.Portal : React.Fragment;

  return (
    <>
      <WrapperPortal>
        <PopoverPrimitive.Content
          align={align}
          sideOffset={iconOffset + buttonOffset + textOffset + sideOffsetNumber}
          collisionPadding={16}
          sticky='always'
          alignOffset={alignOffset}
          className={cn(
            [
              'p-5',
              'z-10',
              'rounded-md',
              'border',
              'bg-white',
              'border-gray-light',
              'shadow-md',
              'will-change-[transform,opacity]',
              'data-[state=open]:data-[side=top]:animate-slide-down-and-fade',
              'data-[state=open]:data-[side=right]:animate-slide-left-and-fade',
              'data-[state=open]:data-[side=bottom]:animate-slide-up-and-fade',
              'data-[state=open]:data-[side=left]:animate-slide-right-and-fade',
            ],
            className
          )}
          {...props}
        >
          {children}
          {showArrow ? <PopoverArrow className={arrowClassName} /> : null}
        </PopoverPrimitive.Content>
      </WrapperPortal>
    </>
  );
};

PopoverContent.displayName = PopoverPrimitive.Content.displayName;

export default PopoverContent;
